import {
  confirmedQualifications,
  confirmedRoles,
  licences,
  shareableProfileVerifiedIdentities,
} from './test-data';
import { getStateTesters, handleQueryError } from './utils';

const { returnEmptyState, returnState } = getStateTesters();

export const personalDetails = () => ({
  firstName: 'Fred',
  lastName: 'Smith',
});

export const summary = () =>
  'Skilled in storytelling and conceptual thinking, I combine these with my working experience in a multidisciplinary and multinational teams to develop a good product.\n\nTest second line text test second line text\n\ntest.com this is a QA testing test description.';

export const languageProficiencies = () => [
  {
    id: '5678',
    name: {
      ontologyId: null,
      text: 'English',
    },
  },
  {
    id: '6789',
    name: {
      ontologyId: null,
      text: 'French',
    },
  },
];

export const shareableProfilePersonalDetails = () => {
  if (returnEmptyState('personalDetails')) {
    return { firstName: null, lastName: null };
  }

  if (returnEmptyState('personalDetailsLastName')) {
    return { firstName: 'Fred', lastName: null };
  }

  return personalDetails();
};

export const shareableProfileSummary = () => {
  if (returnEmptyState('summary')) {
    return null;
  }
  return summary();
};

export const shareableProfileLanguageProficiencies = () => {
  handleQueryError('languages');

  if (returnEmptyState('languages')) {
    return [];
  }

  return languageProficiencies();
};

export const shareableProfileRoles = () => {
  handleQueryError('roles');

  if (returnEmptyState('roles')) {
    return [];
  }

  return confirmedRoles;
};

export const shareableProfileQualifications = () => {
  handleQueryError('education');

  if (returnEmptyState('education')) {
    return [];
  }

  if (returnState('educationIsVerified', 'false')) {
    return [confirmedQualifications[0]];
  }

  return confirmedQualifications;
};

export const shareableProfileLicences = () => {
  handleQueryError('licences');

  if (returnEmptyState('licences')) {
    return [];
  }

  if (returnState('licencesIsVerified', 'false')) {
    return [licences[0]];
  }

  return licences;
};

export const shareableProfileActive = () => {
  if (returnEmptyState('active')) {
    return false;
  }

  return true;
};

export const shareableProfileVerifiedIdentity = () => {
  handleQueryError('verifiedIdentity');

  if (returnEmptyState('verifiedIdentity')) {
    return null;
  }

  if (returnState('verifiedIdentity', 'nameMatch')) {
    return shareableProfileVerifiedIdentities[1];
  }

  return shareableProfileVerifiedIdentities[2];
};
